import { render, staticRenderFns } from "./referralCard.vue?vue&type=template&id=5968b942&scoped=true"
import script from "./referralCard.vue?vue&type=script&lang=js"
export * from "./referralCard.vue?vue&type=script&lang=js"
import style0 from "./referralCard.vue?vue&type=style&index=0&id=5968b942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5968b942",
  null
  
)

export default component.exports